import CustomizedCircularProgress from '@/components/shared/customized-circular-progress';
import { FC } from 'react';
import { Stack } from '@mui/material';
import { pxToRem } from '@/theme/typography';

export const CreditCardsListLoader: FC = () => {
  return (
    <Stack
      sx={{
        paddingY: {
          mobile: '10px',
          tablet: pxToRem(20),
        },
        alignItems: 'center',
      }}
    >
      <CustomizedCircularProgress size={40} />
    </Stack>
  );
};
